import { Serializable } from '../../../core/models/serializable';

export class SalesReportFilterModel
  implements Serializable<SalesReportFilterModel>
{
  fromObject(object: any): SalesReportFilterModel {
    Object.assign(this, object);
    return this;
  }
  toObject() {
    return {
      PortfolioId: this.portfolioId,
      Year: this.year,
      Month: this.month,
      Day: this.day,
      Website: this.website,
    };
  }

  constructor() {
    let now = new Date();
    this.year = now.getFullYear();
    this.month = now.getMonth() + 1;
    this.day = now.getDate();
  }

  public portfolioId: number;
  public year: number;
  public month: number;
  public day: number;

  public website: number;
}
